import React, { Component } from 'react';
import { Card, CardHeader, CardContent, Collapse, Grid, IconButton, Typography } from '@material-ui/core';
import { safeGet, safePost } from '../axios-default';
import Moment from 'moment/moment';
import Zoom from 'react-medium-image-zoom';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from './Modal/modal';

class DraftPhotoViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            unarchived_list: [],
            archived_list: [],
            openUnarchived: true,
            openArchived: true,
            openConfirmDeleteModal: false,
            modalError: '',
            targetDoctorAppFileId: null,
            isLoading: false,
        };
    }

    async componentDidMount() {
        const { unarchived_list, archived_list } = await safeGet('mobile_app/doctor/draft_file_list_all');
        this.setState({ unarchived_list, archived_list });
    }

    async handleConfirmDelete(doctor_app_file_id) {
        this.setState({ isLoading: true });
        const result = await safePost('mobile_app/doctor/delete_draft_file_list', { doctor_app_file_id });
        if (result.success) {
            const { unarchived_list, archived_list } = await safeGet('mobile_app/doctor/draft_file_list_all');
            this.setState({
                unarchived_list,
                archived_list,
                openConfirmDeleteModal: false,
                targetDoctorAppFileId: null,
            });
        } else {
            this.setState({ modalError: result.message ?? 'Failed to delete.' });
        }
        this.setState({ isLoading: false });
    }

    render() {
        return (
            <>
                <Modal
                    title="Confirm Delete?"
                    open={this.state.openConfirmDeleteModal}
                    handleClose={() => this.setState({ openConfirmDeleteModal: false })}
                    submitButton={true}
                    submitButtonLabel="Confirm"
                    handleDataSave={() => this.handleConfirmDelete(this.state.targetDoctorAppFileId)}
                    modalError={this.state.modalError}
                    modalSize="xs"
                    photoUploadLoadingStatus={this.state.isLoading}
                />
                <Card style={{ border: '1px solid grey' }}>
                    <CardHeader
                        title="Your Gallery (Unused)"
                        action={
                            <IconButton
                                color="inherit"
                                onClick={() => this.setState({ openUnarchived: !this.state.openUnarchived })}
                                aria-controls="unarchived-list"
                                aria-expanded={this.state.openUnarchived}
                            >
                                {this.state.openUnarchived ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        }
                    ></CardHeader>
                    <Collapse in={this.state.openUnarchived}>
                        <CardContent id="unarchived-list">
                            <Grid container>
                                {this.state.unarchived_list ? (
                                    <Grid container>
                                        {this.state.unarchived_list.map((photoSet) => (
                                            <Grid item xs={12} md={6} lg={4} xl={3}>
                                                <Card style={{ border: '1px solid black' }}>
                                                    <CardContent>
                                                        <Grid container justifyContent="space-between">
                                                            <Grid item>
                                                                <Typography>
                                                                    Name: {photoSet.first_name} {photoSet.last_name}
                                                                </Typography>
                                                                <Typography>
                                                                    Last update:{' '}
                                                                    {Moment(photoSet.updated_date).format(
                                                                        'DD MMM YYYY'
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                            {['INTERNATIONAL'].includes(process.env.REACT_APP_ENV) && (
                                                                <Grid item alignContent="center">
                                                                    <IconButton
                                                                        style={{ color: 'red' }}
                                                                        size="medium"
                                                                        onClick={() =>
                                                                            this.setState({
                                                                                openConfirmDeleteModal: true,
                                                                                targetDoctorAppFileId:
                                                                                    photoSet.doctor_app_file_id,
                                                                            })
                                                                        }
                                                                    >
                                                                        <DeleteIcon fontSize="medium" />
                                                                    </IconButton>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                        <Grid container>
                                                            {[...Array(9).keys()].map((i) => (
                                                                <Grid item xs={4}>
                                                                    <Zoom zoomMargin={48}>
                                                                        <img
                                                                            src={photoSet[`photo${i}`]}
                                                                            style={{
                                                                                width: '100%',
                                                                                aspectRatio: '1',
                                                                                marginLeft: 'auto',
                                                                                marginRight: 'auto',
                                                                            }}
                                                                        />
                                                                    </Zoom>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ) : (
                                    'No draft photo'
                                )}
                            </Grid>
                        </CardContent>
                    </Collapse>
                </Card>
                <Card style={{ border: '1px solid grey' }}>
                    <CardHeader
                        title="Your Gallery (Used)"
                        action={
                            <IconButton
                                color="inherit"
                                onClick={() => this.setState({ openArchived: !this.state.openArchived })}
                                aria-controls="archived-list"
                                aria-expanded={this.state.openArchived}
                            >
                                {this.state.openArchived ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        }
                    />
                    <Collapse in={this.state.openArchived}>
                        <CardContent id="archived-list">
                            {this.state.archived_list ? (
                                <Grid container>
                                    {this.state.archived_list.map((photoSet) => (
                                        <Grid item xs={12} md={6} lg={4} xl={3}>
                                            <Card style={{ border: '1px solid black' }}>
                                                <CardContent>
                                                    <Typography>
                                                        Name: {photoSet.first_name} {photoSet.last_name}
                                                    </Typography>
                                                    <Typography>
                                                        Last update:{' '}
                                                        {Moment(photoSet.updated_date).format('DD MMM YYYY')}
                                                    </Typography>
                                                    <Typography>Used in case: {photoSet.case_id}</Typography>
                                                    <Typography>Case statue: {photoSet.case_status}</Typography>
                                                    <Grid container>
                                                        {[...Array(9).keys()].map((i) => (
                                                            <Grid item xs={4}>
                                                                <Zoom zoomMargin={48}>
                                                                    <img
                                                                        src={photoSet[`photo${i}`]}
                                                                        style={{
                                                                            width: '100%',
                                                                            aspectRatio: '1',
                                                                            marginLeft: 'auto',
                                                                            marginRight: 'auto',
                                                                        }}
                                                                    />
                                                                </Zoom>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                'No draft photo'
                            )}
                        </CardContent>
                    </Collapse>
                </Card>
            </>
        );
    }
}

export default DraftPhotoViewer;
